import React from 'react';
import SitewideBanner from '@features/sitewide-banner/SidewideBanner';
import Portal from '@/root/portals/Portal';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';

export default () => {
  return (
    <ErrorBoundary silent>
      <Portal selector='#sitewideBannerContainer'>
        {(dataset) => React.createElement(SitewideBanner, dataset)}
      </Portal>
    </ErrorBoundary>
  );
};
